module.exports = __webpack_public_path__ + "web/img/challenge-intro.331acd36.png";